module.exports = __webpack_public_path__ + "img/rivegauche.8e1eae8e.png";